module.exports = __webpack_public_path__ + "img/Download - Blue - Selected.176caf55.png";